import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { role_list } from "../../redux/api/dummyJson";
import { merch_toggle_off, merch_toggle_on } from "../../../assets/imgs";
import StatusComp from "../../../components/StatusComp";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const SuperAdminAddRoles = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [roleList, setRoleList] = useState([]);

  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedPermission_, setSelectedPermission_] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);

  const [seperation, setSepertion] = useState();

  const [role, setRole] = useState("");
  const [errors, setErrors] = useState(false);

  const type = location?.state?.type;
  const id = location?.state?.id;
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));

  const getPermissionsList = async () => {
    get(URL.PERMISSIONS_LIST)
      .then((res) => {
        if (res?.status == "success") {
          let filert_ = res?.modules?.filter((i) => i?.type == 3);
          console.log("filert_", filert_);
          let temp = [];
          filert_?.map((item) => {
            let permissions_ = [];
            item?.permissions?.map((per) => {
              let obj_per = {
                ...per,
              };

              if (per?.name?.includes("knf admin")) {
                if (per?.name?.includes("-knf admin")) {
                  obj_per.name = per?.name?.replace(
                    "-knf admin",
                    "-aiware admin"
                  );
                } else {
                  obj_per.name = per?.name?.replace("knf admin", "aiware");
                }
              } else if (per?.name?.includes("knf super admin")) {
                obj_per.name = per?.name?.replace(
                  "knf super admin",
                  "aiware super admin"
                );
              }

              if (per?.name?.includes("knf admin")) {
                obj_per.name = per?.name?.replace("knf admin", "aiware");
              } else if (per?.name?.includes("knf admin")) {
                obj_per.name = per?.name?.replace("knf", "aiware admin");
              }
              permissions_.push(obj_per);
            });

            let obj = {
              ...item,
              permissions: permissions_,
            };

            if (item?.name?.includes("Knf Admin")) {
              if (item?.name == "Knf Admin") {
                obj.name = "Aiware Admin";
              } else {
                obj.name = item?.name?.replace("Knf Admin", "Aiware");
              }
            } else if (item?.name?.includes("Knf Super Admin")) {
              obj.name = item?.name?.replace(
                "Knf Super Admin",
                "Aiware Super Admin"
              );
            }

            temp.push(obj);
          });

          console.log("temp", temp);

          setRoleList(filert_);
          res?.modules?.map((item) => {
            let obj = {};
            obj.name = item.name;
            obj.permissions = item.permissions;
            setSepertion(obj);
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const roleView = async (id) => {
    get(URL.VIEW_ROLE + id)
      .then((res) => {
        if (res?.status == "success") {
          setRole(res?.role_data?.name);
          setSelectedPermissions(res?.role_data?.permissions);
          let temp = [];
          res?.role?.permissions?.map((item, ind) => {
            temp.push(item?.id);
          });
          // setPermissions(temp);

          let permissions_ = [...res?.role_data?.permissions];
          let parent_id = [];
          res?.modules?.map((item, ind) => {
            let finder = item?.permissions?.filter((i) =>
              permissions_?.includes(i?.id)
            );
            if (item?.permissions?.length == finder?.length) {
              parent_id.push(item?.id);
            }
          });
          setSelectedPermission_(parent_id);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    // console.log(res);
  };

  const Add = async () => {
    if (!role) {
      setError(true);
      return;
    }
    if (selectedPermissions?.length == 0) {
      setError(true);
      return;
    }
    setError(false);
    const formdata = new FormData();
    formdata.append("name", role);
    formdata.append("type", 3);
    selectedPermissions?.map((item, index) => {
      formdata.append(`permissions[${index}]`, item);
    });
    if (type == "edit") {
      formdata.append("role_id", id);
      editRole(formdata);
    } else {
      addRole(formdata);
    }
  };

  const addRole = (formdata) => {
    post(URL.ADD_ROLE, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          navigate("/super-admin-roles");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const editRole = (formdata) => {
    post(URL.UPDATE_ROLE, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          navigate("/super-admin-roles");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPermissionsList();
    if (id) {
      roleView(id);
    }
  }, []);

  // console.log(selectedPermissions);

  // Handle toggling of permissions
  const handlePermissionToggle = (roleId, per_id) => {
    let selectedlist = [];
    let temp = [...selectedPermission_];
    let finder = roleList?.find((i) => i?.id == per_id);
    let permissions_ = finder?.permissions;
    let permissions_id = finder?.permissions?.map((item) => item?.id);

    selectedPermissions.map((item) => {
      if (item != roleId) {
        selectedlist.push(item);
      }
    });
    if (!selectedPermissions?.includes(roleId)) {
      selectedlist.push(roleId);
    }
    setSelectedPermissions(selectedlist);

    let matcher = permissions_id?.filter((i) => selectedlist?.includes(i));
    if (permissions_?.length == matcher?.length) {
      temp.push(per_id);
    } else {
      let inx = temp?.indexOf(per_id);
      if (inx >= 0) {
        temp.splice(inx, 1);
      }
    }
    setSelectedPermission_(temp);
  };

  const selectRoles = () => {
    const allModuleIds = roleList.map((item) => item.id);
    const allPermissionIds = roleList
      .map((item) => item.permissions.map((p) => p.id))
      .flat();

    // console.log(allPermissionIds, "allPermissionIds");

    if (selectedPermissions.length < allPermissionIds.length) {
      setSelectedPermission_(allModuleIds);
      setSelectedPermissions(allPermissionIds);
    } else {
      setSelectedPermission_([]);
      setSelectedPermissions([]);
    }
  };

  // console.log(selectedPermission_, "selectedPermission_");

  const specificRoles = (item) => {
    let ids = [...selectedPermissions];
    let temp = [...selectedPermission_];

    let per_ = [];
    item?.permissions?.map((item) => {
      per_.push(item?.id);
    });

    if (selectedPermission_?.includes(item?.id)) {
      let idx = temp?.indexOf(item?.id);
      temp.splice(idx, 1);
      let newArray = ids.filter((item) => !per_.includes(item));
      ids = newArray;
    } else {
      temp.push(item?.id);
      item?.permissions?.map((item) => {
        ids.push(item?.id);
      });
    }
    setSelectedPermission_(temp);
    setSelectedPermissions(ids);
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Roles"} type={type} />

      <div className="">
        <div className="d-flex ac-jb">
          <div className="">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  mb-1 d-flex">
              Role Name <span className="text-danger">*</span>
            </h4>
            <input
              value={role}
              onChange={(e) => setRole(e.target.value)}
              type="text"
              className="role-input  ps-2 w-100"
              placeholder="Role Name"
              disabled={type == "view" ? true : false}
            />
            {errors && <p className="err">Enter Role Name</p>}
            {/* {error && !name && <p className="err">Enter Role Name</p>} */}
          </div>
          {/* {type != "view" && ( */}
          <div className="">
            <button
              onClick={() => {
                selectRoles();
              }}
              className=" f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-16 fs-xxl-18  add-btn white"
            >
              Select All
            </button>
          </div>
          {/* )} */}
        </div>
        <div className="roles-bg">
          <h4 className="f4 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 mt-3 primary">
            Permissions{" "}
            <span className="err f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14">
              (Atleast one permission is Required)*
            </span>
          </h4>
          {error && selectedPermissions?.length == 0 && (
            <p className="err">Select Permissions</p>
          )}
          <div className="d-flex flex-wrap mt-2 ps-3 gap-2">
            {roleList?.map((item, id) => {
              return (
                <div className="w-24 mt-3 role-box" key={id}>
                  <div className="d-flex ac-js gap-2 mb-3">
                    <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
                      {item?.name}
                    </p>
                    {type != "view" && (
                      <img
                        src={
                          selectedPermission_?.includes(item?.id)
                            ? merch_toggle_on
                            : merch_toggle_off
                        }
                        className="roles-icon pointer"
                        alt=""
                        onClick={() => {
                          specificRoles(item);
                        }}
                      />
                    )}
                  </div>
                  <div className="d-flex ac-js">
                    <div>
                      {item?.permissions?.map((permission, index) => {
                        const isSelected = selectedPermissions?.includes(
                          permission.id
                        );
                        return (
                          <div className="d-flex ac-js gap-2 mb-2" key={index}>
                            <img
                              src={
                                isSelected ? merch_toggle_on : merch_toggle_off
                              }
                              className="roles-icon pointer"
                              alt=""
                              onClick={() => {
                                if (type != "view") {
                                  handlePermissionToggle(
                                    permission.id,
                                    item?.id
                                  );
                                }
                              }}
                            />
                            <p className=" f1 fs-xs-10 trans fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 mb-0 ">
                              {permission?.name}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="d-flex ac-jb">
            <button
              onClick={() => navigate(-1)}
              className="back-btn-roles f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              Back
            </button>
            {(givenpermissions?.includes("CAN-Add-KNF_SUPER_ADMIN_ROLES") ||
              givenpermissions?.includes("CAN-Edit-KNF_SUPER_ADMIN_ROLES")) &&
            type != "view" &&
            selectedPermissions?.length > 0 ? (
              <button
                onClick={() => {
                  Add();
                }}
                className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                {loader && (
                  <div
                    class="spinner-border spinner-border-sm "
                    role="status"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminAddRoles;
